import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { DateField } from '@mews-commander/form';
import { useCalendarService } from '@mews-commander/ui';
import { FormInputField, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { UnicodeEntity } from '@mews/enums';
import { ConfigureSsoPanelFieldNames, ConfigureSsoPanelFormData } from '../useConfigureSsoPanelForm';
import { SsoNotificationEmailField } from './SsoNotificationEmailField';

interface ConfigureSsoPanelTokenFieldsProps {
    secretRequired?: boolean;
}

export function ConfigureSsoPanelTokenFields({ secretRequired = true }: ConfigureSsoPanelTokenFieldsProps) {
    const calendarService = useCalendarService();
    const tomorrow = calendarService.addDays(calendarService.getCurrentDate(), 1);
    const { resetField } = useFormContext<ConfigureSsoPanelFormData>();

    useEffect(() => {
        resetField(ConfigureSsoPanelFieldNames.ClientSecret);
    }, [resetField]);

    return (
        <>
            <FormInputField
                name={ConfigureSsoPanelFieldNames.ClientSecret}
                label={<LocalizedText textKey={TextKey.SsoSetupClientSecret} />}
                size="medium"
                required={secretRequired}
                placeholder={!secretRequired ? UnicodeEntity.Asterisk.repeat(16) : undefined}
            />
            <DateField
                name={ConfigureSsoPanelFieldNames.ExpirationDate}
                size="medium"
                label={<LocalizedText textKey={TextKey.SsoSetupExpirationDate} />}
                required
                mode="utc"
                minDate={tomorrow}
            />
            <SsoNotificationEmailField
                name={ConfigureSsoPanelFieldNames.UserNotifications}
                size="medium"
                label={<LocalizedText textKey={TextKey.EmailAddressPlural} />}
                helper={<LocalizedText textKey={TextKey.SsoSetupUserNotificationsHelper} />}
            />
        </>
    );
}
